<template>
  <div class="notes" ref="notesRef" @click="$event.stopPropagation()">
    <div class="header" :style="{ backgroundColor: themeColor }"></div>
    <div class="footer">
      <a-tooltip>
        <template #title>{{ newNote.public ? '设置私密' : '公开笔记' }}</template>
        <svg class="icon-svg icon-lock" :class="{ noPublic: !newNote?.public }" @click="setPublic()">
          <use :xlink:href="!newNote.public ? '#icon-lock-fill' : '#icon-unlock-fill'" />
        </svg>
      </a-tooltip>
      <a-tooltip>
        <template #title>删除笔记</template>
        <svg class="icon-svg icon-delete" @click="deleteNote()" :style="{ color: themeColor }">
          <use xlink:href="#icon-delete" />
        </svg>
      </a-tooltip>
      <a-tooltip>
        <template #title>关闭</template>
        <svg class="icon-svg icon-close" @click="close()">
          <use xlink:href="#icon-close-fill" />
        </svg>
      </a-tooltip>
    </div>
    <textarea class="textarea" v-model="newNote.content" placeholder="写下这一刻的想法..." @input="handleInput()"></textarea>
  </div>
</template>

<script>
import { debounce } from 'lodash';


export default {
  name: 'note-box',
  components: {},
  props: {
    newNoteId: String,
    userNote: Object,
  },
  data() {
    return {
      newNote: {
        content: '',
        public: true
      },
      themeColor: '#666666'
    }
  },
  mounted() {
    this.newNote = this.userNote.notes.find(item => item.uid == this.newNoteId);

    //监听对话框外部点击
    window.addEventListener('mousedown', e => { this.hideBox(e) })
    //监听对话框外部点击
    window.addEventListener('blur', e => {
      if (document.activeElement && document.activeElement.nodeName.toLocaleLowerCase() == 'iframe') {
        this.close()
      }
    })

  },
  methods: {
    //关闭
    close() {
      this.$emit('closeUpdate', true)
    },
    //改为私密
    setPublic() {
      this.newNote.public = !this.newNote.public;
      this.handleInput();
    },
    //删除note
    async deleteNote() {
      let userNote = this.userNote;
      userNote.notes = userNote.notes.filter(item => item.uid != this.newNoteId);
      let newData = JSON.parse(JSON.stringify(userNote));
      delete newData._id;

      let res = await this.$api.note.createOrUpdate(newData);
      if (res.statusCode != 200) return this.$message.warning(res.message);

      this.$message.success('删除笔记成功');
      this.$emit('deleteNote', true)
    },
    //自动修改note
    handleInput: debounce(async function () {
      let res = await this.$api.note.createOrUpdate(this.userNote);
      if (res.statusCode != 200) return this.$message.warning(res.message);
      this.$emit('refreshList', this.newNote)
    }, 500),

    //隐藏
    hideBox(e) {
      // 获取被点击的元素
      const clickedEl = e.target;
      const notesRef = this.$refs.notesRef;
      if (!clickedEl || !notesRef) return;
      if (!notesRef.contains(clickedEl)) this.close()
    },
  },
  beforeDestroy() {
    window.removeEventListener('mousedown', e => { this.hideBox(e) });
  }
}
</script>

<style scoped lang="scss">
@import "./add-note.scss";
</style>